import React from 'react';
import Image from 'next/image';
import clsx from 'clsx';
import { Typography } from '@/components/common';
import { BadgeTypes, useClaimIcons } from '@/hooks';

interface Props {
	caseName: string;
	category: BadgeTypes;
}

export const RetainerHeader: React.FC<Props> = ({ caseName, category }) => {
	const { getIcon } = useClaimIcons();
	return (
		<div className="relative w-full">
			<div
				className={clsx(
					'pt-6 md:relative',
					'flex flex-col items-center w-full !px-0 gap-4 mb-6 lg:mb-0'
				)}
			>
				<Image src={'/logos/id-logo.png'} alt="" width={240} height={62} />
				<Typography type="semibold-24" className="max-w-2xl text-center">
					{category?.toLowerCase() === 'securities'
						? 'Retainer Agreement for Securities Matters'
						: `Retainer Agreement`}
				</Typography>
				<div className="flex items-center gap-3">
					<div className="flex flex-col md:flex-row items-center gap-2">
						<div>{getIcon(category, '!text-gray-35 fill-gray-35', 25)}</div>
					</div>
					<Typography type="semibold-14" className="text-gray-35 text-center">
						{caseName}
					</Typography>
				</div>
			</div>
		</div>
	);
};
